// Copyright (c) 2017 Deere & Company

import * as ClaimSearchHelper from '../../../shared/services/claim-search-helper';
import React, {Component, PropTypes} from 'react';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import CheckboxWithSearchFilterControlled from '../../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import FacetsDateRangePickerOptionsControlled from '../../../../shared/components/facets/date-range-picker-options/controlled';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../../shared/services/facets';

function handleDealerFilterInput(text) {

    this.props.actions.updateDealerAccountFacetInput(text);

}

function handleDealerAccountFacetItem(item, isSelected) {

    this.props.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleClaimTypeFacetItem(item, isSelected) {

    this.props.actions.updateClaimTypeFacetItem(item, isSelected);

}

function handleClaimStatusFacetItem(item, isSelected) {

    this.props.actions.updateClaimStatusFacetItem(item, isSelected);

}

function handleApplyFilters() {

    if (!isDealerFacetInvalid(this.facets.dealerAccountsFacet)) {

        this.actions.applySearchFilters();

    }

}

function updateDateRangeFacet(dateRange) {

    this.props.actions.updateDateRangeFacet(dateRange);

}

function updateDateType(dateTypeKey) {

    this.props.actions.updateDateType(dateTypeKey);

}

function handleResetFilters() {

    this.props.actions.resetAllFacets(this.props.facets, this.context.user.settings.claims);

}

function toggleDealerAccountFacetItems() {

    this.props.actions.toggleDealerAccountFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function toggleClaimTypeFacetItems() {

    this.props.actions.toggleClaimTypeFacetItems(this.props.facets.claimTypesFacet.allowedTypes);

}

function toggleClaimStatusFacetItems() {

    this.props.actions.toggleClaimStatusFacetItems(this.props.facets.claimStatusFacet.allowedStatus);

}

const loadAllFacetsData = (isInitialLoad, items) => isInitialLoad || items.length === 0;

const initializeFacetData = props => {

    if (loadAllFacetsData(props.facets.dealerAccountsFacet.isInitialLoad, props.facets.dealerAccountsFacet.selectedDealers)) {

        props.actions.selectAllDealersOnInitialLoad(props.facets.dealerAccountsFacet.allowedDealers);

    }
    if (loadAllFacetsData(props.facets.claimStatusFacet.isInitialLoad, props.facets.claimStatusFacet.selectedClaimStatus)) {

        props.actions.selectAllClaimStatusOnInitialLoad(props.facets.claimStatusFacet.allowedStatus);

    }
    if (loadAllFacetsData(props.facets.claimTypesFacet.isInitialLoad, props.facets.claimTypesFacet.selectedClaimTypes)) {

        props.actions.readFacetsData();

    }

};

const initializeClaimTabsData = (props, context) => {

    const showWaitingForDealerInvoice = context.user.privacy.showWaitingForDealerInvoice;

    props.actions.readAllClaims(props.facets.dealerAccountsFacet.isInitialLoad, showWaitingForDealerInvoice);

    if (showWaitingForDealerInvoice) {

        props.actions.readDealerInvoices(props.facets.dealerAccountsFacet.isInitialLoad);

    }

};

class ClaimSearchFacets extends Component {

    state = {
        claimTypeExpanded: false,
        dateRangePickerExpanded: false,
        dealerLocationExpanded: false,
        statusExpanded: false
    };

    componentWillMount() {

        initializeFacetData(this.props);

        if (this.props.queryParams.q && this.props.queryParams.by && this.props.facets.dealerAccountsFacet.isInitialLoad) {

            initializeClaimTabsData(this.props, this.context);

        }

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.claimTypeExpanded || this.state.dateRangePickerExpanded || this.state.dealerLocationExpanded || this.state.statusExpanded;

    render() {

        return (
            <div className='claim-search-facets'>
                <CheckboxWithSearchFilterControlled
                    canUseDefaultFormat={true}
                    initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                    isExpanded={this.state.dealerLocationExpanded}
                    list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                    minNumberOfItems={4}
                    onCheckboxListChange={this::handleDealerAccountFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                    onInputChange={this::handleDealerFilterInput}
                    onToggleAll={this::toggleDealerAccountFacetItems}
                    searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                    searchPlaceholder='DEALER_LOCATION_FILTER'
                    title='DEALER_LOCATIONS'
                    valueKey={'account'}
                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.facets.claimTypesFacet.selectedClaimTypes, 'key')}
                    isExpanded={this.state.claimTypeExpanded}
                    list={addCollectionLabels(this.props.facets.claimTypesFacet.allowedTypes, 'value')}
                    minNumberOfItems={4}
                    onChange={this::handleClaimTypeFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'claimTypeExpanded')}
                    onToggleAll={this::toggleClaimTypeFacetItems}
                    title={'CLAIM_TYPE'}
                    valueKey={'key'}
                />
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.facets.claimStatusFacet.selectedClaimStatus, 'key')}
                    isExpanded={this.state.statusExpanded}
                    list={addCollectionLabels(this.props.facets.claimStatusFacet.allowedStatus, 'value')}
                    minNumberOfItems={4}
                    onChange={this::handleClaimStatusFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'statusExpanded')}
                    onToggleAll={this::toggleClaimStatusFacetItems}
                    title={'STATUS'}
                    valueKey={'key'}
                />
                <FacetsDateRangePickerOptionsControlled
                    className='claim-search-options'
                    dateFormat={this.props.dateFormat}
                    dateRange={this.props.facets.claimDateRangeFacet.dateRange}
                    isExpanded={this.state.dateRangePickerExpanded}
                    isPlaceholderTranslated={true}
                    maxDate={this.props.facets.claimDateRangeFacet.dateRange.maxDate}
                    minDate={this.props.facets.claimDateRangeFacet.dateRange.minDate}
                    onChange={this::updateDateType}
                    onClick={this.onAccordionToggle.bind(this, 'dateRangePickerExpanded')}
                    onDateChange={this::updateDateRangeFacet}
                    optionDisplayAttributes={['value']}
                    optionKey='key'
                    options={ClaimSearchHelper.getClaimFacetOptions()}
                    placeholder=''
                    selectedValue={this.props.facets.dateTypeFacet.key}
                    title={'DATE'}
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)}
                        onApply={this.props::handleApplyFilters}
                        onReset={this::handleResetFilters}
                    /> : null}
            </div>
        );

    }

}

ClaimSearchFacets.displayName = 'ClaimSearchFacets';
ClaimSearchFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    dateFormat: PropTypes.string.isRequired,
    facets: PropTypes.object.isRequired,
    queryParams: PropTypes.object.isRequired
};
ClaimSearchFacets.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimSearchFacets;



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/claim-search-facets/claim-search-facets-container.js